import {MutableRefObject} from "react";
import Dialog from "@Features/dialog/components/Dialog";
import {
    CountAmenityGroupModalTranslationsType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenityGroupModalTranslations.type";
import CountAmenityList
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/components/CountAmenityList";
import AddSelectedAmenities from "@CheckOrder/features/amenities/components/AddSelectedAmenities";
import useCreateTotalPriceOfCurrentlySelectedAmenities
    from "@CheckOrder/features/amenities/features/countAmenity/features/modal/hooks/useCreateTotalPriceOfCurrentlySelectedAmenities";
import Pills from "@Generic/buttons/Pills";
import useSingleAndReturnAmenitiesSelectTabs
    from "@CheckOrder/features/amenities/hooks/useSingleAndReturnAmenitiesSelectTabs";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import useGetAmenitiesCurrency from "@CheckOrder/features/amenities/hooks/useGetAmenitiesCurrency";
import IconTimes from "@Icons/controls/IconTimes";
import useUpdateAmenitiesAndCloseSelection
    from "@CheckOrder/features/amenities/hooks/useUpdateAmenitiesAndCloseSelection";
import useHandleAmenitiesUpdateError from "@CheckOrder/features/amenities/hooks/useHandleAmenitiesUpdateError";
import useLocalCountAmenityStates
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useLocalCountAmenityStates";

interface CountAmenityModalProps {
    dialogRef: MutableRefObject<HTMLDialogElement>
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType,
    translations: CountAmenityGroupModalTranslationsType,
    closeModal: () => void,
    openErrorModal: () => void,
}

function CountAmenityModal(props: CountAmenityModalProps) {
    const {
        pairedAmenityGroups,
        dialogRef,
        translations,
        closeModal,
        openErrorModal,
    } = props

    const {
        title,
        noAmenitiesAdded,
        cta,
    } = translations

    const {
        singleSelectedAmenities,
        setSingleSelectedAmenities,
        returnSelectedAmenities,
        setReturnSelectedAmenities,
    } = useLocalCountAmenityStates()

    const {
        closeAndUpdate,
        closeWithoutUpdating,
        response,
    } = useUpdateAmenitiesAndCloseSelection(
        closeModal,
        singleSelectedAmenities,
        returnSelectedAmenities,
        setSingleSelectedAmenities,
        setReturnSelectedAmenities
    )
    useHandleAmenitiesUpdateError(response, openErrorModal)

    const {
        totalPrice,
    } = useCreateTotalPriceOfCurrentlySelectedAmenities(
        pairedAmenityGroups,
        singleSelectedAmenities,
        returnSelectedAmenities
    )

    const {sign} = useGetAmenitiesCurrency() || {}

    const {isReturn} = useAppSelector((state) => (state.checkOrder.ticket))
    const {selectedTab, tabs} = useSingleAndReturnAmenitiesSelectTabs()

    return (
        <Dialog
            dialogRef={dialogRef}
            className="ticket-amenities__dialog-overlay"
        >
            <button
                type="button"
                className="amenities-overlay__close"
                onClick={closeWithoutUpdating}
            >
                <IconTimes/>
            </button>
            <h2 className="amenities-overlay__title">
                {title}
            </h2>
            {isReturn && (
                <Pills
                    pills={tabs}
                    wrapperClassName="gb--pill-container ticket-amenities__direction-pills"
                    tabClassName="gb--pill amenities-direction-pill"
                />
            )}
            <CountAmenityList
                selectedTab={selectedTab}
                pairedAmenityGroups={pairedAmenityGroups}
                singleSelectedAmenities={singleSelectedAmenities}
                setSingleSelectedAmenities={setSingleSelectedAmenities}
                returnSelectedAmenities={returnSelectedAmenities}
                setReturnSelectedAmenities={setReturnSelectedAmenities}
            />
            <AddSelectedAmenities
                closeAndUpdate={closeAndUpdate}
                cta={cta}
                total={totalPrice !== 0 ? `${totalPrice} ${sign}` : "-"}
            />
        </Dialog>
    )
}

export default CountAmenityModal